import React, { useState, useEffect } from 'react';
import api from '../../services/api';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import { Row, Table, Col, Popconfirm } from 'antd';
import { Form, Button, Select, Checkbox, message } from 'antd';
import ModalModulo from '../../components/ModalModulo';
import PerfisArray from '../../components/enums/perfil.enum'
import { FrownOutlined, } from '@ant-design/icons';
import { useHistory } from 'react-router-dom';
import styles from './style.module.css'

interface ErrorProps {
    modalStatus?: any,
    setNovoModuloModal: any,
    setEditarModuloModal: any
}
const Error: React.FC<ErrorProps> = (props) => {

    const [mensagem, setMensagem] = useState('');
    const history = useHistory();

    useEffect(() => {            
        setMensagem(history.location.state?.mensagem || "Erro Desconhecido!");                        
    }, [])

    return (
        <>
            <Header />
            <br />            
                <div className={ styles.error}>                    
                    <FrownOutlined className={styles.icon} />                                     
                    <span className={styles.mensagem} >{mensagem}</span>                   
                </div>            
            <Footer />
        </>);
}

export default Error;